<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedi"><em class="italic">For Michelle Bullivant</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?43a305fc